// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as React_DOM_Props from "../React.DOM.Props/index.js";
import * as React_SyntheticEvent from "../React.SyntheticEvent/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var PrimProp = /* #__PURE__ */ (function () {
    function PrimProp(value0) {
        this.value0 = value0;
    };
    PrimProp.create = function (value0) {
        return new PrimProp(value0);
    };
    return PrimProp;
})();
var Handler = /* #__PURE__ */ (function () {
    function Handler(value0) {
        this.value0 = value0;
    };
    Handler.create = function (value0) {
        return new Handler(value0);
    };
    return Handler;
})();
var y = function ($36) {
    return PrimProp.create(React_DOM_Props.y($36));
};
var x = function ($37) {
    return PrimProp.create(React_DOM_Props.x($37));
};
var wrap = function ($38) {
    return PrimProp.create(React_DOM_Props.wrap($38));
};
var wmode = function ($39) {
    return PrimProp.create(React_DOM_Props.wmode($39));
};
var width = function ($40) {
    return PrimProp.create(React_DOM_Props.width($40));
};
var vocab = function ($41) {
    return PrimProp.create(React_DOM_Props.vocab($41));
};
var viewBox = function ($42) {
    return PrimProp.create(React_DOM_Props.viewBox($42));
};
var valueArray = function ($43) {
    return PrimProp.create(React_DOM_Props.valueArray($43));
};
var value = function ($44) {
    return PrimProp.create(React_DOM_Props.value($44));
};
var useMap = function ($45) {
    return PrimProp.create(React_DOM_Props.useMap($45));
};
var unselectable = function ($46) {
    return PrimProp.create(React_DOM_Props.unselectable($46));
};
var unsafeTargetValue = function (e) {
    return e.target.value;
};
var unsafeMkPropHandler = function (s) {
    return new Handler(function (f) {
        return React_DOM_Props.unsafeMkProps(s)(Effect_Uncurried.mkEffectFn1(f));
    });
};
var unsafeMkProp = function (s) {
    return function (v) {
        return new PrimProp(React_DOM_Props.unsafeMkProps(s)(v));
    };
};
var $$typeof = function ($47) {
    return PrimProp.create(React_DOM_Props["typeof"]($47));
};
var title = function ($48) {
    return PrimProp.create(React_DOM_Props.title($48));
};
var target = function ($49) {
    return PrimProp.create(React_DOM_Props.target($49));
};
var tabIndex = function ($50) {
    return PrimProp.create(React_DOM_Props.tabIndex($50));
};
var suppressContentEditableWarning = function ($51) {
    return PrimProp.create(React_DOM_Props.suppressContentEditableWarning($51));
};
var summary = function ($52) {
    return PrimProp.create(React_DOM_Props.summary($52));
};
var style = function ($53) {
    return PrimProp.create(React_DOM_Props.style($53));
};
var strokeWidth = function ($54) {
    return PrimProp.create(React_DOM_Props.strokeWidth($54));
};
var stroke = function ($55) {
    return PrimProp.create(React_DOM_Props.stroke($55));
};
var step = function ($56) {
    return PrimProp.create(React_DOM_Props.step($56));
};
var start = function ($57) {
    return PrimProp.create(React_DOM_Props.start($57));
};
var srcSet = function ($58) {
    return PrimProp.create(React_DOM_Props.srcSet($58));
};
var srcLang = function ($59) {
    return PrimProp.create(React_DOM_Props.srcLang($59));
};
var srcDoc = function ($60) {
    return PrimProp.create(React_DOM_Props.srcDoc($60));
};
var src = function ($61) {
    return PrimProp.create(React_DOM_Props.src($61));
};
var spellCheck = function ($62) {
    return PrimProp.create(React_DOM_Props.spellCheck($62));
};
var span = function ($63) {
    return PrimProp.create(React_DOM_Props.span($63));
};
var sizes = function ($64) {
    return PrimProp.create(React_DOM_Props.sizes($64));
};
var size = function ($65) {
    return PrimProp.create(React_DOM_Props.size($65));
};
var shape = function ($66) {
    return PrimProp.create(React_DOM_Props.shape($66));
};
var selected = function ($67) {
    return PrimProp.create(React_DOM_Props.selected($67));
};
var security = function ($68) {
    return PrimProp.create(React_DOM_Props.security($68));
};
var seamless = function ($69) {
    return PrimProp.create(React_DOM_Props.seamless($69));
};
var scrolling = function ($70) {
    return PrimProp.create(React_DOM_Props.scrolling($70));
};
var scoped = function ($71) {
    return PrimProp.create(React_DOM_Props.scoped($71));
};
var scope = function ($72) {
    return PrimProp.create(React_DOM_Props.scope($72));
};
var sandbox = function ($73) {
    return PrimProp.create(React_DOM_Props.sandbox($73));
};
var rows = function ($74) {
    return PrimProp.create(React_DOM_Props.rows($74));
};
var rowSpan = function ($75) {
    return PrimProp.create(React_DOM_Props.rowSpan($75));
};
var role = function ($76) {
    return PrimProp.create(React_DOM_Props.role($76));
};
var reversed = function ($77) {
    return PrimProp.create(React_DOM_Props.reversed($77));
};
var results = function ($78) {
    return PrimProp.create(React_DOM_Props.results($78));
};
var resource = function ($79) {
    return PrimProp.create(React_DOM_Props.resource($79));
};
var required = function ($80) {
    return PrimProp.create(React_DOM_Props.required($80));
};
var rel = function ($81) {
    return PrimProp.create(React_DOM_Props.rel($81));
};
var ref = function ($82) {
    return PrimProp.create(React_DOM_Props.ref($82));
};
var readOnly = function ($83) {
    return PrimProp.create(React_DOM_Props.readOnly($83));
};
var radioGroup = function ($84) {
    return PrimProp.create(React_DOM_Props.radioGroup($84));
};
var r = function ($85) {
    return PrimProp.create(React_DOM_Props.r($85));
};
var property = function ($86) {
    return PrimProp.create(React_DOM_Props.property($86));
};
var profile = function ($87) {
    return PrimProp.create(React_DOM_Props.profile($87));
};
var preload = function ($88) {
    return PrimProp.create(React_DOM_Props.preload($88));
};
var prefix = function ($89) {
    return PrimProp.create(React_DOM_Props.prefix($89));
};
var poster = function ($90) {
    return PrimProp.create(React_DOM_Props.poster($90));
};
var points = function ($91) {
    return PrimProp.create(React_DOM_Props.points($91));
};
var placeholder = function ($92) {
    return PrimProp.create(React_DOM_Props.placeholder($92));
};
var persist = function (v) {
    if (v instanceof Handler) {
        return new Handler(function (hdlr) {
            return v.value0(function (e) {
                return function __do() {
                    var v1 = React_SyntheticEvent.persist(e)();
                    return hdlr(e)();
                };
            });
        });
    };
    if (v instanceof PrimProp) {
        return new PrimProp(v.value0);
    };
    throw new Error("Failed pattern match at Concur.React.Props (line 109, column 1 - line 111, column 36): " + [ v.constructor.name ]);
};
var pattern = function ($93) {
    return PrimProp.create(React_DOM_Props.pattern($93));
};
var optimum = function ($94) {
    return PrimProp.create(React_DOM_Props.optimum($94));
};
var open = function ($95) {
    return PrimProp.create(React_DOM_Props.open($95));
};
var opacity = function ($96) {
    return PrimProp.create(React_DOM_Props.opacity($96));
};
var onWheelCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onWheelCapture);
})();
var onWheel = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onWheel);
})();
var onWaitingCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onWaitingCapture);
})();
var onWaiting = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onWaiting);
})();
var onVolumeChangeCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onVolumeChangeCapture);
})();
var onVolumeChange = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onVolumeChange);
})();
var onTransitionEndCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTransitionEndCapture);
})();
var onTransitionEnd = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTransitionEnd);
})();
var onTouchStartCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchStartCapture);
})();
var onTouchStart = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchStart);
})();
var onTouchMoveCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchMoveCapture);
})();
var onTouchMove = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchMove);
})();
var onTouchEndCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchEndCapture);
})();
var onTouchEnd = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchEnd);
})();
var onTouchCancelCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchCancelCapture);
})();
var onTouchCancel = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTouchCancel);
})();
var onToggleCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onToggleCapture);
})();
var onToggle = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onToggle);
})();
var onTimeUpdateCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTimeUpdateCapture);
})();
var onTimeUpdate = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onTimeUpdate);
})();
var onSuspendCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSuspendCapture);
})();
var onSuspend = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSuspend);
})();
var onSubmitCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSubmitCapture);
})();
var onSubmit = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSubmit);
})();
var onStalledCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onStalledCapture);
})();
var onStalled = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onStalled);
})();
var onSelectCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSelectCapture);
})();
var onSelect = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSelect);
})();
var onSeekingCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSeekingCapture);
})();
var onSeeking = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSeeking);
})();
var onSeekedCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSeekedCapture);
})();
var onSeeked = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onSeeked);
})();
var onScrollCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onScrollCapture);
})();
var onScroll = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onScroll);
})();
var onRateChangeCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onRateChangeCapture);
})();
var onRateChange = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onRateChange);
})();
var onProgressCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onProgressCapture);
})();
var onProgress = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onProgress);
})();
var onPlayingCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPlayingCapture);
})();
var onPlaying = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPlaying);
})();
var onPlayCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPlayCapture);
})();
var onPlay = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPlay);
})();
var onPauseCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPauseCapture);
})();
var onPause = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPause);
})();
var onPasteCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPasteCapture);
})();
var onPaste = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onPaste);
})();
var onMouseUpCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseUpCapture);
})();
var onMouseUp = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseUp);
})();
var onMouseOverCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseOverCapture);
})();
var onMouseOver = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseOver);
})();
var onMouseOutCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseOutCapture);
})();
var onMouseOut = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseOut);
})();
var onMouseMoveCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseMoveCapture);
})();
var onMouseMove = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseMove);
})();
var onMouseLeaveCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseLeaveCapture);
})();
var onMouseLeave = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseLeave);
})();
var onMouseEnterCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseEnterCapture);
})();
var onMouseEnter = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseEnter);
})();
var onMouseDownCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseDownCapture);
})();
var onMouseDown = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onMouseDown);
})();
var onLoadedMetadataCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadedMetadataCapture);
})();
var onLoadedMetadata = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadedMetadata);
})();
var onLoadedDataCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadedDataCapture);
})();
var onLoadedData = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadedData);
})();
var onLoadStartCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadStartCapture);
})();
var onLoadStart = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadStart);
})();
var onLoadCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoadCapture);
})();
var onLoad = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onLoad);
})();
var onKeyUpCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyUpCapture);
})();
var onKeyUp = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyUp);
})();
var onKeyPressCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyPressCapture);
})();
var onKeyPress = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyPress);
})();
var onKeyDownCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyDownCapture);
})();
var onKeyDown = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onKeyDown);
})();
var onInvalidCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onInvalidCapture);
})();
var onInvalid = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onInvalid);
})();
var onInputCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onInputCapture);
})();
var onInput = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onInput);
})();
var onFocusCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onFocusCapture);
})();
var onFocus = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onFocus);
})();
var onErrorCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onErrorCapture);
})();
var onError = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onError);
})();
var onEndedCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEndedCapture);
})();
var onEnded = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEnded);
})();
var onEncryptedCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEncryptedCapture);
})();
var onEncrypted = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEncrypted);
})();
var onEmptiedCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEmptiedCapture);
})();
var onEmptied = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onEmptied);
})();
var onDurationChangeCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDurationChangeCapture);
})();
var onDurationChange = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDurationChange);
})();
var onDropCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDropCapture);
})();
var onDrop = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDrop);
})();
var onDragStartCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragStartCapture);
})();
var onDragStart = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragStart);
})();
var onDragOverCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragOverCapture);
})();
var onDragOver = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragOver);
})();
var onDragLeaveCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragLeaveCapture);
})();
var onDragLeave = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragLeave);
})();
var onDragExitCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragExitCapture);
})();
var onDragExit = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragExit);
})();
var onDragEnterCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragEnterCapture);
})();
var onDragEnter = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragEnter);
})();
var onDragEndCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragEndCapture);
})();
var onDragEnd = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragEnd);
})();
var onDragCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDragCapture);
})();
var onDrag = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDrag);
})();
var onDoubleClickCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDoubleClickCapture);
})();
var onDoubleClick = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onDoubleClick);
})();
var onCutCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCutCapture);
})();
var onCut = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCut);
})();
var onCopyCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCopyCapture);
})();
var onCopy = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCopy);
})();
var onContextMenuCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onContextMenuCapture);
})();
var onContextMenu = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onContextMenu);
})();
var onCompositionUpdateCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionUpdateCapture);
})();
var onCompositionUpdate = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionUpdate);
})();
var onCompositionStartCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionStartCapture);
})();
var onCompositionStart = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionStart);
})();
var onCompositionEndCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionEndCapture);
})();
var onCompositionEnd = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCompositionEnd);
})();
var onClickCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onClickCapture);
})();
var onClick = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onClick);
})();
var onChangeCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onChangeCapture);
})();
var onChange = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onChange);
})();
var onCanPlayThroughCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCanPlayThroughCapture);
})();
var onCanPlayThrough = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCanPlayThrough);
})();
var onCanPlayCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCanPlayCapture);
})();
var onCanPlay = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onCanPlay);
})();
var onBlurCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onBlurCapture);
})();
var onBlur = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onBlur);
})();
var onAnimationStartCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationStartCapture);
})();
var onAnimationStart = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationStart);
})();
var onAnimationIterationCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationIterationCapture);
})();
var onAnimationIteration = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationIteration);
})();
var onAnimationEndCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationEndCapture);
})();
var onAnimationEnd = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAnimationEnd);
})();
var onAbortCapture = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAbortCapture);
})();
var onAbort = /* #__PURE__ */ (function () {
    return new Handler(React_DOM_Props.onAbort);
})();
var nonce = function ($97) {
    return PrimProp.create(React_DOM_Props.nonce($97));
};
var noValidate = function ($98) {
    return PrimProp.create(React_DOM_Props.noValidate($98));
};
var name = function ($99) {
    return PrimProp.create(React_DOM_Props.name($99));
};
var muted = function ($100) {
    return PrimProp.create(React_DOM_Props.muted($100));
};
var multiple = function ($101) {
    return PrimProp.create(React_DOM_Props.multiple($101));
};
var mkProp = function (v) {
    return function (v1) {
        if (v1 instanceof PrimProp) {
            return v1.value0;
        };
        if (v1 instanceof Handler) {
            return v1.value0(v);
        };
        throw new Error("Failed pattern match at Concur.React.Props (line 24, column 1 - line 28, column 7): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var minLength = function ($102) {
    return PrimProp.create(React_DOM_Props.minLength($102));
};
var min = function ($103) {
    return PrimProp.create(React_DOM_Props.min($103));
};
var method = function ($104) {
    return PrimProp.create(React_DOM_Props.method($104));
};
var mediaGroup = function ($105) {
    return PrimProp.create(React_DOM_Props.mediaGroup($105));
};
var media = function ($106) {
    return PrimProp.create(React_DOM_Props.media($106));
};
var maxLength = function ($107) {
    return PrimProp.create(React_DOM_Props.maxLength($107));
};
var max = function ($108) {
    return PrimProp.create(React_DOM_Props.max($108));
};
var marginWidth = function ($109) {
    return PrimProp.create(React_DOM_Props.marginWidth($109));
};
var marginHeight = function ($110) {
    return PrimProp.create(React_DOM_Props.marginHeight($110));
};
var manifest = function ($111) {
    return PrimProp.create(React_DOM_Props.manifest($111));
};
var low = function ($112) {
    return PrimProp.create(React_DOM_Props.low($112));
};
var loop = function ($113) {
    return PrimProp.create(React_DOM_Props.loop($113));
};
var list = function ($114) {
    return PrimProp.create(React_DOM_Props.list($114));
};
var lang = function ($115) {
    return PrimProp.create(React_DOM_Props.lang($115));
};
var label = function ($116) {
    return PrimProp.create(React_DOM_Props.label($116));
};
var kind = function ($117) {
    return PrimProp.create(React_DOM_Props.kind($117));
};
var keyType = function ($118) {
    return PrimProp.create(React_DOM_Props.keyType($118));
};
var keyParams = function ($119) {
    return PrimProp.create(React_DOM_Props.keyParams($119));
};
var key = function ($120) {
    return PrimProp.create(React_DOM_Props.key($120));
};
var itemType = function ($121) {
    return PrimProp.create(React_DOM_Props.itemType($121));
};
var itemScope = function ($122) {
    return PrimProp.create(React_DOM_Props.itemScope($122));
};
var itemRef = function ($123) {
    return PrimProp.create(React_DOM_Props.itemRef($123));
};
var itemProp = function ($124) {
    return PrimProp.create(React_DOM_Props.itemProp($124));
};
var itemID = function ($125) {
    return PrimProp.create(React_DOM_Props.itemID($125));
};
var isEnterEvent = function (e) {
    return e.which === 13 || e.keyCode === 13;
};
var is = function ($126) {
    return PrimProp.create(React_DOM_Props.is($126));
};
var integrity = function ($127) {
    return PrimProp.create(React_DOM_Props.integrity($127));
};
var inputMode = function ($128) {
    return PrimProp.create(React_DOM_Props.inputMode($128));
};
var inlist = function ($129) {
    return PrimProp.create(React_DOM_Props.inlist($129));
};
var icon = function ($130) {
    return PrimProp.create(React_DOM_Props.icon($130));
};
var httpEquiv = function ($131) {
    return PrimProp.create(React_DOM_Props.httpEquiv($131));
};
var htmlFor = function ($132) {
    return PrimProp.create(React_DOM_Props.htmlFor($132));
};
var hrefLang = function ($133) {
    return PrimProp.create(React_DOM_Props.hrefLang($133));
};
var href = function ($134) {
    return PrimProp.create(React_DOM_Props.href($134));
};
var high = function ($135) {
    return PrimProp.create(React_DOM_Props.high($135));
};
var hidden = function ($136) {
    return PrimProp.create(React_DOM_Props.hidden($136));
};
var height = function ($137) {
    return PrimProp.create(React_DOM_Props.height($137));
};
var headers = function ($138) {
    return PrimProp.create(React_DOM_Props.headers($138));
};
var handleProp = function (v) {
    return function (v1) {
        if (v1 instanceof PrimProp) {
            return new PrimProp(v1.value0);
        };
        if (v1 instanceof Handler) {
            return new PrimProp(v1.value0(v));
        };
        throw new Error("Failed pattern match at Concur.React.Props (line 33, column 1 - line 37, column 15): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var functorProps = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof PrimProp) {
                return new PrimProp(v1.value0);
            };
            if (v1 instanceof Handler) {
                return new Handler(function (k) {
                    return v1.value0(function ($139) {
                        return k(v($139));
                    });
                });
            };
            throw new Error("Failed pattern match at Concur.React.Props (line 19, column 1 - line 21, column 48): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var frameBorder = function ($140) {
    return PrimProp.create(React_DOM_Props.frameBorder($140));
};
var formTarget = function ($141) {
    return PrimProp.create(React_DOM_Props.formTarget($141));
};
var formNoValidate = function ($142) {
    return PrimProp.create(React_DOM_Props.formNoValidate($142));
};
var formMethod = function ($143) {
    return PrimProp.create(React_DOM_Props.formMethod($143));
};
var formEncType = function ($144) {
    return PrimProp.create(React_DOM_Props.formEncType($144));
};
var formAction = function ($145) {
    return PrimProp.create(React_DOM_Props.formAction($145));
};
var form = function ($146) {
    return PrimProp.create(React_DOM_Props.form($146));
};
var filterProp = function (v) {
    return function (v1) {
        if (v1 instanceof PrimProp) {
            return v1;
        };
        if (v1 instanceof Handler) {
            return new Handler(function (h) {
                return v1.value0(function (a) {
                    var $34 = v(a);
                    if ($34) {
                        return h(a);
                    };
                    return pure(Data_Unit.unit);
                });
            });
        };
        throw new Error("Failed pattern match at Concur.React.Props (line 43, column 1 - line 47, column 15): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var onKeyEnter = /* #__PURE__ */ filterProp(isEnterEvent)(onKeyDown);
var fillOpacity = function ($147) {
    return PrimProp.create(React_DOM_Props.fillOpacity($147));
};
var fill = function ($148) {
    return PrimProp.create(React_DOM_Props.fill($148));
};
var encType = function ($149) {
    return PrimProp.create(React_DOM_Props.encType($149));
};
var emptyProp = /* #__PURE__ */ (function () {
    return new PrimProp($foreign.emptyProp_);
})();
var draggable = function ($150) {
    return PrimProp.create(React_DOM_Props.draggable($150));
};
var download = function ($151) {
    return PrimProp.create(React_DOM_Props.download($151));
};
var disabled = function ($152) {
    return PrimProp.create(React_DOM_Props.disabled($152));
};
var dir = function ($153) {
    return PrimProp.create(React_DOM_Props.dir($153));
};
var defer = function ($154) {
    return PrimProp.create(React_DOM_Props.defer($154));
};
var defaultValue = function ($155) {
    return PrimProp.create(React_DOM_Props.defaultValue($155));
};
var defaultChecked = function ($156) {
    return PrimProp.create(React_DOM_Props.defaultChecked($156));
};
var $$default = function ($157) {
    return PrimProp.create(React_DOM_Props["default"]($157));
};
var dateTime = function ($158) {
    return PrimProp.create(React_DOM_Props.dateTime($158));
};
var datatype = function ($159) {
    return PrimProp.create(React_DOM_Props.datatype($159));
};
var dangerouslySetInnerHTML = function ($160) {
    return PrimProp.create(React_DOM_Props.dangerouslySetInnerHTML($160));
};
var d = function ($161) {
    return PrimProp.create(React_DOM_Props.d($161));
};
var cy = function ($162) {
    return PrimProp.create(React_DOM_Props.cy($162));
};
var cx = function ($163) {
    return PrimProp.create(React_DOM_Props.cx($163));
};
var crossOrigin = function ($164) {
    return PrimProp.create(React_DOM_Props.crossOrigin($164));
};
var coords = function ($165) {
    return PrimProp.create(React_DOM_Props.coords($165));
};
var controls = function ($166) {
    return PrimProp.create(React_DOM_Props.controls($166));
};
var contextMenu = function ($167) {
    return PrimProp.create(React_DOM_Props.contextMenu($167));
};
var contentEditable = function ($168) {
    return PrimProp.create(React_DOM_Props.contentEditable($168));
};
var content = function ($169) {
    return PrimProp.create(React_DOM_Props.content($169));
};
var cols = function ($170) {
    return PrimProp.create(React_DOM_Props.cols($170));
};
var color = function ($171) {
    return PrimProp.create(React_DOM_Props.color($171));
};
var colSpan = function ($172) {
    return PrimProp.create(React_DOM_Props.colSpan($172));
};
var className = function ($173) {
    return PrimProp.create(React_DOM_Props.className($173));
};
var classList = /* #__PURE__ */ (function () {
    var $174 = Data_Array.intercalate(Data_Monoid.monoidString)(" ");
    var $175 = Data_Array.concatMap(Data_Maybe.maybe([  ])(function (s) {
        return [ s ];
    }));
    return function ($176) {
        return className($174($175($176)));
    };
})();
var classID = function ($177) {
    return PrimProp.create(React_DOM_Props.classID($177));
};
var cite = function ($178) {
    return PrimProp.create(React_DOM_Props.cite($178));
};
var checked = function ($179) {
    return PrimProp.create(React_DOM_Props.checked($179));
};
var charSet = function ($180) {
    return PrimProp.create(React_DOM_Props.charSet($180));
};
var challenge = function ($181) {
    return PrimProp.create(React_DOM_Props.challenge($181));
};
var cellSpacing = function ($182) {
    return PrimProp.create(React_DOM_Props.cellSpacing($182));
};
var cellPadding = function ($183) {
    return PrimProp.create(React_DOM_Props.cellPadding($183));
};
var capture = function ($184) {
    return PrimProp.create(React_DOM_Props.capture($184));
};
var autoSave = function ($185) {
    return PrimProp.create(React_DOM_Props.autoSave($185));
};
var autoPlay = function ($186) {
    return PrimProp.create(React_DOM_Props.autoPlay($186));
};
var autoFocus = function ($187) {
    return PrimProp.create(React_DOM_Props.autoFocus($187));
};
var autoCorrect = function ($188) {
    return PrimProp.create(React_DOM_Props.autoCorrect($188));
};
var autoComplete = function ($189) {
    return PrimProp.create(React_DOM_Props.autoComplete($189));
};
var autoCapitalize = function ($190) {
    return PrimProp.create(React_DOM_Props.autoCapitalize($190));
};
var async = function ($191) {
    return PrimProp.create(React_DOM_Props.async($191));
};
var aria = function ($192) {
    return PrimProp.create(React_DOM_Props.aria($192));
};
var alt = function ($193) {
    return PrimProp.create(React_DOM_Props.alt($193));
};
var allowTransparency = function ($194) {
    return PrimProp.create(React_DOM_Props.allowTransparency($194));
};
var allowFullScreen = function ($195) {
    return PrimProp.create(React_DOM_Props.allowFullScreen($195));
};
var action = function ($196) {
    return PrimProp.create(React_DOM_Props.action($196));
};
var accessKey = function ($197) {
    return PrimProp.create(React_DOM_Props.accessKey($197));
};
var acceptCharset = function ($198) {
    return PrimProp.create(React_DOM_Props.acceptCharset($198));
};
var accept = function ($199) {
    return PrimProp.create(React_DOM_Props.accept($199));
};
var about = function ($200) {
    return PrimProp.create(React_DOM_Props.about($200));
};
var _type = function ($201) {
    return PrimProp.create(React_DOM_Props["_type"]($201));
};
var _id = function ($202) {
    return PrimProp.create(React_DOM_Props["_id"]($202));
};
var _data = function ($203) {
    return PrimProp.create(React_DOM_Props["_data"]($203));
};
export {
    emptyProp_,
    resetTargetValue
} from "./foreign.js";
export {
    PrimProp,
    Handler,
    mkProp,
    handleProp,
    filterProp,
    emptyProp,
    unsafeMkPropHandler,
    unsafeMkProp,
    classList,
    unsafeTargetValue,
    isEnterEvent,
    persist,
    aria,
    _data,
    style,
    dangerouslySetInnerHTML,
    accept,
    acceptCharset,
    accessKey,
    action,
    allowFullScreen,
    allowTransparency,
    alt,
    async,
    autoComplete,
    autoFocus,
    autoPlay,
    capture,
    cellPadding,
    cellSpacing,
    charSet,
    challenge,
    checked,
    cite,
    classID,
    className,
    cols,
    colSpan,
    content,
    contentEditable,
    contextMenu,
    controls,
    coords,
    crossOrigin,
    dateTime,
    $$default as default,
    defaultChecked,
    defaultValue,
    defer,
    dir,
    disabled,
    download,
    draggable,
    encType,
    form,
    formAction,
    formEncType,
    formMethod,
    formNoValidate,
    formTarget,
    frameBorder,
    headers,
    height,
    hidden,
    high,
    href,
    hrefLang,
    htmlFor,
    httpEquiv,
    icon,
    _id,
    inputMode,
    integrity,
    is,
    key,
    keyParams,
    keyType,
    kind,
    label,
    lang,
    list,
    loop,
    low,
    manifest,
    marginHeight,
    marginWidth,
    max,
    maxLength,
    media,
    mediaGroup,
    method,
    min,
    minLength,
    multiple,
    muted,
    name,
    nonce,
    noValidate,
    open,
    optimum,
    pattern,
    placeholder,
    poster,
    preload,
    profile,
    radioGroup,
    readOnly,
    rel,
    required,
    reversed,
    role,
    rows,
    rowSpan,
    sandbox,
    scope,
    scoped,
    scrolling,
    seamless,
    selected,
    shape,
    size,
    sizes,
    span,
    spellCheck,
    src,
    srcDoc,
    srcLang,
    srcSet,
    start,
    step,
    summary,
    tabIndex,
    target,
    title,
    _type,
    useMap,
    value,
    valueArray,
    width,
    wmode,
    wrap,
    about,
    datatype,
    inlist,
    prefix,
    property,
    resource,
    $$typeof as typeof,
    vocab,
    autoCapitalize,
    autoCorrect,
    autoSave,
    color,
    itemProp,
    itemScope,
    itemType,
    itemID,
    itemRef,
    results,
    security,
    unselectable,
    onAnimationStart,
    onAnimationEnd,
    onAnimationIteration,
    onTransitionEnd,
    onToggle,
    onError,
    onLoad,
    onAbort,
    onCanPlay,
    onCanPlayThrough,
    onDurationChange,
    onEmptied,
    onEncrypted,
    onEnded,
    onLoadedData,
    onLoadedMetadata,
    onLoadStart,
    onPause,
    onPlay,
    onPlaying,
    onProgress,
    onRateChange,
    onSeeked,
    onSeeking,
    onStalled,
    onSuspend,
    onTimeUpdate,
    onVolumeChange,
    onWaiting,
    onCopy,
    onCut,
    onPaste,
    onCompositionEnd,
    onCompositionStart,
    onCompositionUpdate,
    onKeyDown,
    onKeyPress,
    onKeyUp,
    onKeyEnter,
    onFocus,
    onBlur,
    onChange,
    onInput,
    onInvalid,
    onSubmit,
    onClick,
    onContextMenu,
    onDoubleClick,
    onDrag,
    onDragEnd,
    onDragEnter,
    onDragExit,
    onDragLeave,
    onDragOver,
    onDragStart,
    onDrop,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onSelect,
    onTouchCancel,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    onScroll,
    onWheel,
    onAnimationStartCapture,
    onAnimationEndCapture,
    onAnimationIterationCapture,
    onTransitionEndCapture,
    onToggleCapture,
    onErrorCapture,
    onLoadCapture,
    onAbortCapture,
    onCanPlayCapture,
    onCanPlayThroughCapture,
    onDurationChangeCapture,
    onEmptiedCapture,
    onEncryptedCapture,
    onEndedCapture,
    onLoadedDataCapture,
    onLoadedMetadataCapture,
    onLoadStartCapture,
    onPauseCapture,
    onPlayCapture,
    onPlayingCapture,
    onProgressCapture,
    onRateChangeCapture,
    onSeekedCapture,
    onSeekingCapture,
    onStalledCapture,
    onSuspendCapture,
    onTimeUpdateCapture,
    onVolumeChangeCapture,
    onWaitingCapture,
    onCopyCapture,
    onCutCapture,
    onPasteCapture,
    onCompositionEndCapture,
    onCompositionStartCapture,
    onCompositionUpdateCapture,
    onKeyDownCapture,
    onKeyPressCapture,
    onKeyUpCapture,
    onFocusCapture,
    onBlurCapture,
    onChangeCapture,
    onInputCapture,
    onInvalidCapture,
    onSubmitCapture,
    onClickCapture,
    onContextMenuCapture,
    onDoubleClickCapture,
    onDragCapture,
    onDragEndCapture,
    onDragEnterCapture,
    onDragExitCapture,
    onDragLeaveCapture,
    onDragOverCapture,
    onDragStartCapture,
    onDropCapture,
    onMouseDownCapture,
    onMouseEnterCapture,
    onMouseLeaveCapture,
    onMouseMoveCapture,
    onMouseOutCapture,
    onMouseOverCapture,
    onMouseUpCapture,
    onSelectCapture,
    onTouchCancelCapture,
    onTouchEndCapture,
    onTouchMoveCapture,
    onTouchStartCapture,
    onScrollCapture,
    onWheelCapture,
    ref,
    suppressContentEditableWarning,
    x,
    y,
    cx,
    cy,
    r,
    fill,
    opacity,
    fillOpacity,
    stroke,
    strokeWidth,
    points,
    d,
    viewBox,
    functorProps
};
//# sourceMappingURL=index.js.map
